/**
 * Dedupes concurrent store-scoped GET requests. Returns cached data when the same
 * username was already loaded; reuses in-flight promises for parallel callers.
 *
 * @param {{ key: string, force?: boolean, cacheRef: object, pendingRef: object, isCacheHit: (cache: object) => boolean, getCachedValue: (cache: object) => *, runRequest: () => Promise<*> }} options
 */
const dedupeStoreFetch = async ({
    key,
    force = false,
    cacheRef,
    pendingRef,
    isCacheHit,
    getCachedValue,
    runRequest,
}) => {
    if (!key) {
        return null;
    }

    if (!force && isCacheHit(cacheRef.current)) {
        return getCachedValue(cacheRef.current);
    }

    if (!force) {
        const inFlight = pendingRef.current.get(key);
        if (inFlight) {
            return inFlight;
        }
    } else {
        pendingRef.current.delete(key);
    }

    const promise = (async () => {
        try {
            return await runRequest();
        } finally {
            pendingRef.current.delete(key);
        }
    })();

    pendingRef.current.set(key, promise);
    return promise;
};

export default dedupeStoreFetch;
